import { Injectable, EventEmitter } from '@angular/core'
import { Apollo } from 'apollo-angular'
import { Observable } from 'rxjs'
import gql from 'graphql-tag'
import { map, startWith, tap } from 'rxjs/operators'
import { sortBy } from 'lodash-es'


export interface DeclineReason {
  id: number;
  reason: string;
  other: boolean;
}

@Injectable({providedIn: 'root'})
export class DeclineReasonQueries {
  private _declineReasons: DeclineReason[] = []
  private declineReasonEmitter: EventEmitter<DeclineReason[]> = new EventEmitter<DeclineReason[]>()

  constructor(private apollo: Apollo) {
    this.apollo.query<{declineReasons: DeclineReason[]}>({
      query: gql`
        query DeclineReasonsQuery {
          declineReasons {
            id
            reason
            other
          }
        }
      `
    })
    .pipe(
      map(result => result?.data?.declineReasons || []),
      // Always put 'Other' at the end of the list
      map(declineReasons => sortBy(declineReasons, dr => dr.other ? 1 : -1)),
      tap(declineReasons => this._declineReasons = declineReasons),
    )
    .subscribe(() => {
      this.declineReasonEmitter.emit(this._declineReasons)
    })
  }

  public declineReasons(): Observable<DeclineReason[]> {
    return this.declineReasonEmitter.pipe(
      startWith(this._declineReasons)
    )
  }
}
